module.exports = __webpack_public_path__ + "img/mobile/PromoHistory/Promo_Spin_Icon@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/PromoHistory/Promo_Spin_Icon@3x.png
// module id = 120
// module chunks = 0